import React from 'react';
import styles from './onboarding-title-desc.scss';

interface OnboardingTitleDescProps {
  className?: string;
  title: string;
  desc?: string;
  style?: React.CSSProperties;
}

export const OnboardingTitleDesc = ({ className, title, desc, style = {} }: OnboardingTitleDescProps) => (
  <div className={className} style={style}>
    <h1 className={styles.title}>{title}</h1>
    {desc && <h2 className={styles.desc}>{desc}</h2>}
  </div>
);
